import { Row, Col } from "reactstrap";
import CardItem from "./cardItem"; 
import mountIcon from "../../assets/images/Arrow.png";
import dollardIcon from "../../assets/images/Dollard.png";
import rowDown from "../../assets/images/rowDown.png";
import twoRow from "../../assets/images/twoRow.png";
// import useConvertedCurrency from "../../common/convert/ConvertCurrendy";

const CardMetrics = ({ data, turnOver, isLoading, isError, error }) => {

  // const amount = data?.balance || 0;

  // const {
  //   convertedTurnOver,
  //   isLoading: isConvertLoading,
  //   isError: isConvertError,
  //   error: convertError,
  // } = useConvertedCurrency(amount, fromCurrency, toCurrency);
  
  return (
    <Row className="mb-3">
      <Col lg={3} className="mb-2">
        <CardItem
          title="Solde disponible"
          icon={mountIcon}
          counterEnd={data?.availableBalance}
          currency={data?.currency}
          isLoading={isLoading}
          isError={isError}
          error={error}
          frozen={data?.totalFrozenAmount}
        />
      </Col>
      <Col lg={3} className="mb-2">
        <CardItem
          title="Montant encaissé"
          icon={dollardIcon}
          counterEnd={data?.balance}
          currency={data?.currency}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </Col>
      <Col lg={3} className="mb-2">
        <CardItem
          title="Versement"
          icon={rowDown}
          counterEnd={data?.totalTransferAmount ? data?.totalTransferAmount : data?.totalTransfert}
          currency={data?.currency}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </Col>
      <Col lg={3} className="mb-2">
        <CardItem
          title="Chiffre d'affaire"
          icon={twoRow}
          counterEnd={turnOver}
          currency={data?.currency}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </Col>
    </Row>
  );
};

export default CardMetrics;
